import { createSlice } from '@reduxjs/toolkit';
import { getShowPrices, setShowPrices } from '../../utilities/priceVisibilityStore';

export const PriceVisibilitySlice = createSlice({
  name: 'priceVisibility',
  initialState: { showPrices: getShowPrices() },
  reducers: {
    setPriceVisibility: (state, action) => {
      state.showPrices = Boolean(action.payload);
      setShowPrices(state.showPrices);
    },
    hydratePriceVisibility: (state) => {
      state.showPrices = getShowPrices();
    },
  },
});

export default PriceVisibilitySlice.reducer;
export const { setPriceVisibility, hydratePriceVisibility } = PriceVisibilitySlice.actions;
